import { render, staticRenderFns } from "./ASelecionar-modulos.vue?vue&type=template&id=15291f3e"
import script from "./ASelecionar-modulos.vue?vue&type=script&lang=js"
export * from "./ASelecionar-modulos.vue?vue&type=script&lang=js"
import style0 from "./ASelecionar-modulos.vue?vue&type=style&index=0&id=15291f3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports